// extracted by mini-css-extract-plugin
module.exports = {"stars":"Rating_stars__aSUkY","small":"Rating_small__cNLX_","light":"Rating_light__3_Qwh"};